const validator = require('./validator').validator;
const inOutFormatDecorator = require('./validator').inOutFormatDecorator;

const authentication = {
    meteorUserId: { type: 'stringID' },
    meteorLoginToken: { type: 'Token' }
};

const OAuth = {
    userId: { type: 'object' },
    idToken: { type: 'string', presence: false },
    oAuthProvider: { type: 'string' }
};

module.exports = {
    authentication: {
        schema: authentication,
        validate: inOutFormatDecorator(validator, authentication)
    },
    OAuth: {
        schema: OAuth,
        validate: inOutFormatDecorator(validator, OAuth)
    }
};
